import { FC } from 'react';
import { ReactComponent as AddIcon } from 'resources/images/add.svg';
import { useAppSelector } from 'app/store';
import { getCreateIsniLink } from 'app/store/Profile/selectors';
import { Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { IdType } from 'types/enums';
import { ChakraFabButton } from 'app/components/Core';

interface AddIdNumberFabProps {
  onSelect: (idType: IdType) => void;
}

interface AddIdNumberFabComponentProps {
  onSelect: (idType: IdType) => void;
  canAddIsni?: boolean;
}

export const AddIdNumberFabComponent: FC<AddIdNumberFabComponentProps> = ({
  onSelect,
  canAddIsni,
}) => {
  return (
    <Menu placement="top-end" isLazy>
      <ChakraFabButton
        as={MenuButton}
        sx={{
          '> span': {
            display: 'flex',
            alignItems: 'center',
          },
        }}
        aria-label="add id"
        leftIcon={<AddIcon />}
      >
        Add ID
      </ChakraFabButton>
      <MenuList>
        <MenuItem minW="120px" onClick={() => onSelect(IdType.IPI)}>
          IPI Number
        </MenuItem>
        <MenuItem onClick={() => onSelect(IdType.IPN)}>IPN Number</MenuItem>
        {canAddIsni && (
          <MenuItem onClick={() => onSelect(IdType.ISNI)}>ISNI Number</MenuItem>
        )}
      </MenuList>
    </Menu>
  );
};

export const AddIdNumberFab: FC<AddIdNumberFabProps> = ({ onSelect }) => {
  const createIsniLink = useAppSelector(getCreateIsniLink);

  return (
    <AddIdNumberFabComponent
      onSelect={onSelect}
      canAddIsni={Boolean(createIsniLink)}
    />
  );
};
